<div class="qr-login-container">
    <div class="qr-login-header">Scan QR Code to Log In</div>
    <div class="qr-login-why">To use the desktop client, we must verify your location through the SOPO mobile app.</div>
    <div class="qr-login-instruction">Scan this QR code using your phone's camera, or use the QR scanner in the SOPO app under Profile <ion-icon name="desktop-outline"></ion-icon>.</div>

    <div class="error-message" *ngIf="error">{{ error }}</div>

    <div class="qr-code-wrapper" *ngIf="!loading && !expired">
        <qrcode
            [qrdata]="qrData"
            [width]="256"
            errorCorrectionLevel="H"
            colorDark="#1a1a1a"
            colorLight="#ffffff"
        ></qrcode>
        <div class="qr-logo">
            <img src="assets/icon/sopo-diamond-logo.webp" alt="SOPO" />
        </div>
    </div>

    <div class="qr-expired" *ngIf="expired">
        <div class="expired-text">QR code expired</div>
        <ion-button shape="round" (click)="refresh()">
            <span>Refresh</span>
        </ion-button>
    </div>

    <div class="qr-skeleton" *ngIf="loading">
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
    </div>
</div>
